import config from '../config';

const parseLimit = (value: string | undefined, fallback: number): number => {
  const parsed = Number.parseInt(value || '', 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const getSiteLimitForPlan = (planTier?: string): number => {
  const normalizedPlanTier = (planTier || '').trim().toUpperCase();

  switch (normalizedPlanTier) {
    case 'PRO':
    case 'PROFESSIONAL':
      return parseLimit(config.VITE_SITE_LIMIT_PRO, 10);
    case 'AGENCY':
      return parseLimit(config.VITE_SITE_LIMIT_AGENCY, 125);
    case 'STARTER':
    case 'BASIC':
    default:
      return parseLimit(
        normalizedPlanTier === 'BASIC' ? config.VITE_SITE_LIMIT_BASIC : config.VITE_SITE_LIMIT_STARTER,
        1,
      );
  }
};

export const getSiteLimitMessage = (planTier?: string): string => {
  const normalizedPlanTier = (planTier || 'STARTER').trim().toUpperCase();
  const siteLimit = getSiteLimitForPlan(normalizedPlanTier);
  return `${normalizedPlanTier} plan allows maximum ${siteLimit} ${siteLimit === 1 ? 'site' : 'sites'}.`;
};